import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=17bd1ea3&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17bd1ea3"]])

export default __exports__